<template>
  <renderless-laravel-vue-pagination
    :data="data"
    :limit="limit"
    :show-disabled="showDisabled"
    :size="size"
    :align="align"
    v-on:pagination-change-page="onPaginationChangePage"
  >
    fufhgf
    <ul
      class="pagination"
      :class="{
        'pagination-sm': size == 'small',
        'pagination-lg': size == 'large',
        'justify-content-center': align == 'center',
        'justify-content-end': align == 'right',
      }"
      v-if="computed.total > computed.perPage"
      slot-scope="{
        data,
        limit,
        showDisabled,
        size,
        align,
        computed,
        prevButtonEvents,
        nextButtonEvents,
        pageButtonEvents,
      }"
    >
      <li
        class="prev"
        :class="{ disabled: !computed.prevPageUrl }"
        v-if="computed.prevPageUrl || showDisabled"
      >
        <a
          class="page-link"
          href="#"
          aria-label="Previous"
          :tabindex="!computed.prevPageUrl && -1"
          v-on="prevButtonEvents"
        >
          <slot name="prev-nav">
            <ArrowDown />
          </slot>
        </a>
      </li>

      <li
        class=""
        v-for="(page, key) in computed.pageRange"
        :key="key"
        :class="{ active: page == computed.currentPage }"
      >
        <a class="page-link" href="#" v-on="pageButtonEvents(page)">
          {{ page }}
          <span class="sr-only" v-if="page == computed.currentPage"
            >(current)</span
          >
        </a>
      </li>

      <li
        class="next"
        :class="{ disabled: !computed.nextPageUrl }"
        v-if="computed.nextPageUrl || showDisabled"
      >
        <a
          class="page-link"
          href="#"
          aria-label="Next"
          :tabindex="!computed.nextPageUrl && -1"
          v-on="nextButtonEvents"
        >
          <slot name="next-nav">
            <ArrowDown />
          </slot>
        </a>
      </li>
    </ul>
  </renderless-laravel-vue-pagination>
</template>

<script>
import ArrowDown from "../../../Icons/icon-arrow-down";
import RenderlessLaravelVuePagination from "./RenderlessLaravelVuePagination.vue";

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    limit: {
      type: Number,
      default: 0,
    },
    showDisabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "default",
      validator: (value) => {
        return ["small", "default", "large"].indexOf(value) !== -1;
      },
    },
    align: {
      type: String,
      default: "left",
      validator: (value) => {
        return ["left", "center", "right"].indexOf(value) !== -1;
      },
    },
  },

  methods: {
    onPaginationChangePage(page) {
      this.$emit("pagination-change-page", page);
    },
  },

  components: {
    RenderlessLaravelVuePagination,
    ArrowDown,
  },
};
</script>

<style lang="scss" scoped>
//Pagination

.pagination {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: flex-start;
  padding-left: 0;
  margin-top: 3rem;

  a {
    display: block;
    font-size: 1.3rem;
    line-height: 3rem;
    min-width: 3rem;
    height: 3rem;
    color: var(--typo-light);
    text-align: center;
    text-decoration: none;
    padding: 0 0.2rem;
    transition: all 0.5s;
    &:hover {
      text-decoration: none;
      color: var(--primary-color);
    }
  }

  i {
    font-size: inherit;
    line-height: inherit;
    color: inherit;
  }

  li {
    list-style: none;
    background-color: #fff;
    border: 0.1rem solid var(--border-color);
    border-radius: var(--radius);
    transition: all 0.5s;
    &:not(:last-child) {
      margin-right: 0.5rem;
    }
    &:hover,
    &.active {
      color: var(--primary-color);
      border-color: var(--primary-color);
      a {
        color: inherit;
      }
    }
    &.disabled {
      opacity: 0.5;
    }
    &.prev {
      transform: rotate(90deg);
    }
    &.next {
      transform: rotate(-90deg);
    }
  }
}
</style>
<style lang="scss">
.pagination a:hover {
  path {
    stroke: var(--primary-color);
  }
}
</style>
